module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<g>\n  <g transform="translate(-35, 0)" stroke="#FFFFFF">\n    <circle fill="none" transform="translate(10.000000, 10.299988) translate(-10.000000, -10.299988) " cx="10" cy="10.2999878" r="10"></circle>\n    <path fill="#FFFFFF" d="M7.03328542,17.0188737 L6.03389459,15.9839742 L10.0497645,12.1058936 L13.9278451,16.1217636 L12.9284543,17.0868641 L10.0497645,14.1058936 L7.03328542,17.0188737 Z" ></path>\n    <path fill="#FFFFFF" d="M7.03328542,8.91298004 L6.03389459,7.87808054 L10.0497645,4 L13.9278451,8.01586996 L12.9284543,8.98097046 L10.0497645,6 L7.03328542,8.91298004 Z" transform="translate(0, 12.596379) scale(1, -1)"></path>\n  </g>\n</g>\n';

}
return __p
};


//////////////////
// WEBPACK FOOTER
// ./app/templates/upbacker.html
// module id = 147
// module chunks = 0